import { Icon, Tooltip } from '@loadsmart/miranda-react'

import { type DocumentStatus } from '../../domain/Document'
import { getDocumentIcon, getDocumentStatusLabel } from '../../presenters/documentPresenter'

type DocumentIconStatusProps = {
  readonly status?: DocumentStatus | null
}

export function DocumentIconStatus({ status }: DocumentIconStatusProps) {
  const { name, color } = getDocumentIcon(status)
  const documentStatusLabel = getDocumentStatusLabel(status)

  if (!documentStatusLabel) {
    return <Icon data-testid={`document-icon-${name}`} name={name} size="small" color={color} />
  }

  return (
    <Tooltip data-testid="tooltip-document-status" message={documentStatusLabel}>
      <Icon data-testid={`document-icon-${status}`} name={name} size="small" color={color} />
    </Tooltip>
  )
}
